import styled from "styled-components";

export const ErrorContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #fff;
  background: #1a1a1a;
`;

export const RefreshButton = styled.button`
  padding: 10px 20px;
  background: #854CE6;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #6b3db8;
  }
`; 